import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function ReceivablesHeader() { return ( <ContentHeader title='Receivables Report' /> ) }

export default React.memo(ReceivablesHeader)
